<template lang='pug'>
	.the-map-menu
		.menu__button(@click='toggleView', :class=`{ 'selected': $store.getters.is3D }`) 3D
		.menu__button(@click='toggleBase') MAP
</template>

<script>
export default {
	name: 'the-map-menu',
	methods: {
		toggleView () {
			this.$store.dispatch('toggleView')
		},
		toggleBase () {
			this.$store.dispatch('toggleBase')
		}
	}
}
</script>

<style scoped>
.the-map-menu {
	position: absolute;
	right: 0;
	bottom: 0;
	padding: 20px;
	display: flex;
}
.menu__button {
	margin: 0 2px;
	font-size: 0.75rem;
	border-radius: 50%;
	width: 32px;
	height: 32px;
	line-height: 32px;
	text-align: center;
	user-select: none;
	box-shadow: 0 1px 3px 0 rgba(0,0,0,.3);
	cursor: pointer;
	background: #fff;
	color: #80808d;
	transition: all .2s ease-out;
}
.selected {
	color: #EF4222;
}
</style>